import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { MasterService } from "../../master/services/master-service";
import { DatePipe } from "@angular/common";
import { CommonHelper } from "src/app/helper/helper.component";
import { FormBuilder, FormGroup } from "@angular/forms";

@Component({
  selector: "app-district-reports",
  templateUrl: "./district-reports.component.html",
  styleUrls: ["./district-reports.component.scss"],
  providers: [MasterService, DatePipe, CommonHelper],
})
export class DistrictReportsComponent implements OnInit {
  dataTable: any;
  stateId: string = "";
  filterForm: FormGroup;
  data: any = {
    district: "",
  };
  showPickerStart = false;
  startDateTime: any = '';
  maxDate = new Date();
  showDateStart = true;
  showTimeStart = false;
  closeButtonStart: any = { show: true, label: 'Close Me!', cssClass: 'btn btn-sm btn-primary' };
  showPickerEnd = false;
  endDateTime: any = '';
  showDateEnd = true;
  showTimeEnd = false;
  DistrictCountsData: any;
  stateData: any;
  submitted: boolean;
  emptyDataCheck: boolean;
  constructor(
    private spinner: NgxSpinnerService,
    private masterService: MasterService,
    private chRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private datepipe: DatePipe,
  ) { }

  ngOnInit() {
    this.getStates();
    this.filterDefaultValues();
  }

  filterDefaultValues() {
    this.filterForm = this.fb.group({
      selectedState: [],
      startDateTime: [''],
      endDateTime: [''],
    });
  }

  onTogglePicker(value) {
    if (value == 'startDT') {
      if (this.showPickerStart === false) {
        this.showPickerStart = true;

      }
    }
    if (value == 'endDT') {
      if (this.showPickerEnd === false) {
        this.showPickerEnd = true;
      }
    }
  }

  getDistrictCountsData() {
    try {
      if (!this.startDateTime && !this.endDateTime) {
        this.startDateTime = '';
        this.endDateTime = '';
      }
      this.spinner.show();
      this.masterService
        .postData(
          "reports/complaints/summary?state_id=" +
          this.stateId +
          "&district=true&start_date=" + this.startDateTime + "&end_date=" + this.endDateTime,
          ""
        )
        .subscribe(
          (response: any) => {
            if (response.status == 200) {
              // this.DistrictCountsData = response.data;
              if (response.data.length > 0) {
                this.spinner.hide();
                this.DistrictCountsData = response.data;

                const table: any = $("#dataTable2");
                this.reploatingDataTable();
                this.chRef.detectChanges();
                this.dataTable = table
                  .DataTable({ order: [[0, "desc"]] })
                  .draw();
              } else {
                this.spinner.hide();
                this.DistrictCountsData = [];
                this.reploatingDataTable();
                this.chRef.detectChanges();
                const table: any = $("#dataTable2");
                this.dataTable = table.DataTable().draw();
              }
            } else {
              this.spinner.hide();
            }
          },
          (error) => {
            this.spinner.hide();
          }
        );
    } catch (exc) { }
  }
  /*redraw the datatable*/
  reploatingDataTable() {
    let table = $("#dataTable2").DataTable();
    table.destroy();
  }

  getStates() {
    this.masterService.getAll("active_states").subscribe((response: any) => {
      if (response.status == 200) {
        this.stateData = response.data;
      } else {
        this.stateData = [];
      }
    });
  }

  onValueChange(val, endorstart) {
    if (endorstart == 'startDT') {
      val = this.datepipe.transform(val, "yyyy-MM-dd")
      this.startDateTime = val;
      this.submitted = false;
    }
    if (endorstart == 'endDT') {
      val = this.datepipe.transform(val, "yyyy-MM-dd")
      this.endDateTime = val;
      this.submitted = false;
    }
  }
  selectedState(event: any) {
    this.stateId = event.id;
    this.getDistrictCountsData();
  }

  downLoadExcelReport() {
    try {
      this.spinner.show();
      this.masterService
        .getAll("export-report?state_id=" + this.stateId + "&district=true")
        .subscribe((response: any) => {
          if (response) {
            window.open(response.data, "_blank");
            this.spinner.hide();
          } else {
          }
        });
    } catch (error) {
      this.spinner.hide();
    }
  }

  submitReport() {
    let sDate = this.datepipe.transform(this.startDateTime, "yyyy-MM-dd"),
      eDate = this.datepipe.transform(this.endDateTime, "yyyy-MM-dd");
    if (this.stateId) {
      if (sDate) {
        if (eDate) {
          if (sDate >= eDate) {
            this.submitted = true;
            this.emptyDataCheck = false;
          } else {
            this.submitted = false;
            this.getDistrictCountsData();
          }
        } else {
          this.submitted = false;
          this.getDistrictCountsData()
        }
      } else {
        this.submitted = false;
        this.getDistrictCountsData()
      }
    }
    else {
      this.submitted = false;
    }

  }

  clear() {
    this.filterForm.reset();
    this.startDateTime = '';
    this.endDateTime = '';
  }
}
